import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
export default {
  props: {
    tagsData: {
      type: Array,
      required: true
    }
  },
  watch: {
    tagsData: {
      handler(newV) {
        this.currentTagData = newV;
        this.selectList = [];
        this.currentTagData.map(item => {
          if (item.checked) {
            this.selectList.push({
              fieldName: item.fieldName,
              fieldValue: item.fieldValue
            });
          }
        });
      },
      deep: true
    }
  },
  data() {
    return {
      currentTagData: [],
      selectList: []
    };
  },
  created() {
    this.currentTagData = this.$props.tagsData;
  },
  methods: {
    selectTagChange(index, tag, checked) {
      tag.checked = checked;
      if (checked) {
        this.selectList.push({
          fieldName: tag.fieldName,
          fieldValue: tag.fieldValue
        });
      } else {
        this.selectList.map((item, i) => {
          if (item.fieldName === tag.fieldName && item.fieldValue === tag.fieldValue) {
            this.selectList.splice(i, 1);
          }
        });
      }
      // debugger;
      this.$emit('changeData', this.selectList);
    }
  }
};